"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiffPaymentApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class LiffPaymentApi extends runtime.BaseAPI {
    /**
     * 建立轉轉貼訂單
     */
    apiLiffPaymentCreateOrderPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/LiffPayment/CreateOrder`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffCreateOrderModelToJSON)(requestParameters['liffCreateOrderModel']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 建立轉轉貼訂單
     */
    apiLiffPaymentCreateOrderPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.apiLiffPaymentCreateOrderPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     * 建立付款請求（產生藍新金流加密資料）
     */
    apiLiffPaymentCreatePaymentPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/LiffPayment/CreatePayment`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffPaymentRequestModelToJSON)(requestParameters['liffPaymentRequestModel']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 建立付款請求（產生藍新金流加密資料）
     */
    apiLiffPaymentCreatePaymentPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.apiLiffPaymentCreatePaymentPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     * 查詢訂單付款狀態
     */
    apiLiffPaymentGetOrderStatusGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['orderNo'] != null) {
                queryParameters['orderNo'] = requestParameters['orderNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/LiffPayment/GetOrderStatus`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 查詢訂單付款狀態
     */
    apiLiffPaymentGetOrderStatusGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.apiLiffPaymentGetOrderStatusGetRaw(requestParameters, initOverrides);
        });
    }
    /**
     * 取得合作店家自訂價格
     */
    apiLiffPaymentGetPartnerPricesGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['orgId'] != null) {
                queryParameters['orgId'] = requestParameters['orgId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/LiffPayment/GetPartnerPrices`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 取得合作店家自訂價格
     */
    apiLiffPaymentGetPartnerPricesGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.apiLiffPaymentGetPartnerPricesGetRaw(requestParameters, initOverrides);
        });
    }
    /**
     * 藍新金流付款結果回呼（NotifyURL）
     */
    apiLiffPaymentHandleCallbackPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['status'] != null) {
                formParams.append('Status', requestParameters['status']);
            }
            if (requestParameters['tradeInfo'] != null) {
                formParams.append('TradeInfo', requestParameters['tradeInfo']);
            }
            if (requestParameters['tradeSha'] != null) {
                formParams.append('TradeSha', requestParameters['tradeSha']);
            }
            const response = yield this.request({
                path: `/api/LiffPayment/HandleCallback`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 藍新金流付款結果回呼（NotifyURL）
     */
    apiLiffPaymentHandleCallbackPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.apiLiffPaymentHandleCallbackPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     * 付款完成返回頁面
     */
    apiLiffPaymentHandleReturnPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['status'] != null) {
                formParams.append('Status', requestParameters['status']);
            }
            if (requestParameters['tradeInfo'] != null) {
                formParams.append('TradeInfo', requestParameters['tradeInfo']);
            }
            if (requestParameters['tradeSha'] != null) {
                formParams.append('TradeSha', requestParameters['tradeSha']);
            }
            const response = yield this.request({
                path: `/api/LiffPayment/HandleReturn`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 付款完成返回頁面
     */
    apiLiffPaymentHandleReturnPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.apiLiffPaymentHandleReturnPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     * 合作店家掃描消費者 QRCode → 建立訂單 + 觸發付款
     */
    apiLiffPaymentPartnerScanPayPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/LiffPayment/PartnerScanPay`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffPartnerScanPayModelToJSON)(requestParameters['liffPartnerScanPayModel']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 合作店家掃描消費者 QRCode → 建立訂單 + 觸發付款
     */
    apiLiffPaymentPartnerScanPayPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.apiLiffPaymentPartnerScanPayPostRaw(requestParameters, initOverrides);
        });
    }
}
exports.LiffPaymentApi = LiffPaymentApi;
